module.exports = __webpack_public_path__ + "static/media/03.c386c4cc.png";